// @file Analytics methods for google analytics and rudderstack
// https://whimsical.com/how-to-track-front-end-events-data-with-rudderstack-N3YL9QPbPCEZ8vN2E4uQtq

function buildRudderOptions() {
  const options = { traits: { ...window.$pepinTraits } }
  if (window.$utmParams != null) {
    options.context = { campaign: window.$utmParams }
  }
  return options
}

/**
 * Track user action events. Note we type params as `any` as callers have been passing in wrong types.
 * @param {string} category - High level grouping (component name like "Audio Booth" or generic like "Surface", "Homepage")
 * @param {any} action - (string) Action description in "verb (past tense) + action" format (e.g., "Created post", "Archived padlet")
 * @param {any} [label] - (string) Optional specific details (e.g., post title, search query)
 * @param {any} [value] - (number) Optional numeric value (e.g., subscription amount, audio/video length)
 * @param {any} [eventProps] - (object) Optional custom properties dictionary
 */
const trackEvent = function (category, action, label, value, eventProps) {
  if (window.rudderanalytics && window.$pepinTraits) {
    const rudderEvent = 'user_action'
    const rudderProperties = { category, action, label, value, eventProps }
    window.rudderanalytics.track(rudderEvent, rudderProperties, buildRudderOptions())
  }
}
// Function to track pageview for javascript pages
const trackPageview = function (category, name) {
  if (window.rudderanalytics && window.$pepinTraits) {
    window.rudderanalytics.page(category, name, undefined, buildRudderOptions())
  }
}
// Function to track engagement time in a wall
const trackWallEngagementTime = function () {
  if (window.rudderanalytics && window.$pepinTraits) {
    const rudderOptions = buildRudderOptions()
    rudderOptions.traits.pingIntervalInMilliseconds = 15_000
    window.rudderanalytics.track('wall_engagement_time_ping', {}, rudderOptions)
  }
}

export { trackEvent, trackPageview, trackWallEngagementTime }
